var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSocialMediaLinkedIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "social-media-linked-in") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Social-Media/Linked-In",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Export"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.029,13.8708889 L19.147,13.8708889 L19.147,16.2851389 L19.22,16.2851389 C19.932,14.8966111 21.675,13.4330556 24.273,13.4330556 C29.678,13.4330556 30.677,17.0888611 30.677,21.8443889 L30.677,31.5281111 L25.339,31.5281111 L25.339,22.9410278 C25.339,20.8936944 25.304,18.2595 22.564,18.2595 C19.786,18.2595 19.362,20.4908056 19.362,22.7950833 L19.362,31.5281111 L14.029,31.5281111 L14.029,13.8708889 Z M8.008,5.09366667 C9.716,5.09366667 11.103,6.51919444 11.103,8.27566667 C11.103,10.0331667 9.716,11.4586944 8.008,11.4586944 C6.293,11.4586944 4.911,10.0331667 4.911,8.27566667 C4.911,6.51919444 6.293,5.09366667 8.008,5.09366667 Z M5.335,31.5281111 L5.335,13.8708889 L10.679,13.8708889 L10.679,31.5281111 L5.335,31.5281111 Z",
    id: "Mask"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialMediaLinkedIn);
export default __webpack_public_path__ + "static/media/icon-social-media-linked-in.6b898e90b7d0b846b2d89b7858c7c993.svg";
export { ForwardRef as ReactComponent };